import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { Redirect } from 'react-router';
import { useBlockingLoader } from 'hooks/loader-hooks';
import { useAuth } from 'AuthCtx';
import { useAlerts } from 'hooks/alerts-hooks';
import ConfirmationCodeVerification from './ConfirmationCodeVerification';

export default function ForgotPasswordForm() {
  const [ step, setStep ] = useState(0);
  const [ newPassword, setNewPassword ] = useState(null);

  const { forgotPassword, forgotPasswordSubmit, deliveryDetails } = useAuth();

  const { showBlockingLoader, hideBlockingLoader } = useBlockingLoader('forgot-password-form');
  const { alertError, alertSuccess } = useAlerts();

  const [ email, setEmail ] = useState('');
  const [ password, setPassword ] = useState('');

  const [ passwordVisibility, setPasswordVisibility ] = useState(false);
  const togglePasswordVisibility = () => {
    return setPasswordVisibility((prev) => {
      return !prev;
    });
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    // Validate email

    Promise.resolve()
      .then(() => {
        showBlockingLoader();
      })
      .then(() => {
        return forgotPassword({ username: email });
      })
      .then(() => {
        setStep((s) => { return s + 1; });
      })
      .catch((err) => {
        alertError(err.message);
      })
      .finally(() => {
        hideBlockingLoader();
      });
  };

  const handleNewPassword = (e) => {
    e.preventDefault();

    // Validate password

    Promise.resolve()
      .then(() => {
        showBlockingLoader();
      })
      .then(() => {
        setNewPassword(password);
        setStep((s) => { return s + 1; });
      })
      .catch((err) => {
        alertError(err.message);
      })
      .finally(() => {
        hideBlockingLoader();
      });
  };

  const handleVerify = (code) => {
    Promise.resolve()
      .then(() => {
        showBlockingLoader();
      })
      .then(() => {
        return forgotPasswordSubmit({ code, newPassword });
      })
      .catch((err) => {
        alertError(err.message);
        throw err;
      })
      .then(() => {
        alertSuccess('Your password has changed');
      })
      .then(() => {
        setStep((s) => { return s + 1; });
      })
      .catch(() => {

      })
      .finally(() => {
        hideBlockingLoader();
      });
  };

  if (0 === step) {
    return (
      <Container>
        <div>
          <Typography component='div' variant='h5' color='primary'>
            Password Recovery
          </Typography>
          <form
            noValidate
            onSubmit={ (e) => {
              return handleForgotPassword(e);
            } }
          >
            <Grid container spacing={ 2 }>
              <Grid item xs={ 12 }>
                <TextField
                  size='small'
                  variant='outlined'
                  required
                  fullWidth
                  label='Username'
                  name='username'
                  value={ email }
                  onChange={ (e) => {
                    return setEmail(e.target.value);
                  } }
                />
              </Grid>
              <Grid item xs={ 12 }>
                <Button
                  fullWidth
                  type='submit'
                  variant='outlined'
                  color='primary'
                >
                  Recovery
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    );
  }

  if (1 === step) {
    return (
      <Container>
        <div>
          <Typography component='div' variant='h5' color='primary'>
            Password recovery
          </Typography>
          <Grid>
            <Typography align='left' component='div' variant='body1' color='textSecondary'>
              Enter your new password
            </Typography>
          </Grid>
          <form
            noValidate
            onSubmit={ (e) => {
              return handleNewPassword(e);
            } }
          >
            <Grid container spacing={ 2 }>
              <Grid item xs={ 12 }>
                <TextField
                  size='small'
                  onChange={ (e) => {
                    return setPassword(e.target.value);
                  } }
                  variant='outlined'
                  required
                  fullWidth
                  name='password'
                  label='New password'
                  type={ passwordVisibility ? 'text' : 'password' }
                  autoComplete='new-password'
                  InputProps={ {
                    endAdornment: (
                      <InputAdornment position='start'>
                        <IconButton onClick={ togglePasswordVisibility }>
                          {!passwordVisibility ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  } }
                />
              </Grid>
              <Grid item xs={ 12 }>
                <Button
                  fullWidth
                  type='submit'
                  variant='outlined'
                  color='primary'
                >
                  Next step
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    );
  }

  if (2 === step) {
    const {
      CodeDeliveryDetails: {
        Destination,
      },
    } = deliveryDetails;

    const subtitle = `'The code has been sent to you at': ${ Destination }`;

    return (
      <Container>
        <div>
          <Typography component='div' variant='h5' color='primary'>
            Confirm change password
          </Typography>
          <Grid>
            <Typography
              align='left'
              component='div'
              variant='body2'
              color='textSecondary'
              style={ { marginBottom: '50px' } }
            >
              {subtitle}
            </Typography>
          </Grid>
          <Grid container spacing={ 2 }>
            <ConfirmationCodeVerification onVerify={ handleVerify } />
          </Grid>

        </div>
      </Container>
    );
  }

  return <Redirect to='/login' />;
}

